import React from "react";

export default function FilterPills({ options, value, onChange, counts = {}, testid }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid={testid}>
      {options.map(([k, l]) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
          className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${value === k ? "text-black border-transparent" : "border-white/10 text-gray-300 hover:border-[#D4AF37]/50"}`}
          style={value === k ? { background: "var(--gold)" } : {}}>
          {l}{counts[k] != null && <span className="ml-1 opacity-70">{counts[k]}</span>}
        </button>
      ))}
    </div>
  );
}
